export default __webpack_public_path__ + "static/media/spinner.a7a5219e.svg";